export default __webpack_public_path__ + "static/destiny-8bc89a7ea1413da17508ecfed9cf2a60.jpg";